module.exports = __webpack_public_path__ + "images/newerp_button1.1789608252531.png";